import { InternalEventApiBase } from './base';

export class InternalEventLogApi extends InternalEventApiBase {
  listForNamespace(query, namespace, id) {
    const namespaceField = `${namespace}_id`;

    return super.get(`log/${query}&${namespaceField}=${id}`, 'Failed to list event logs');
  }
}
